import React, { Component } from 'react';
const autoBind = require('auto-bind');

class RZSkillDetailItem extends React.Component {

    /**
     * @param {Object} props 
     * @example
     * list = ["You can start a Chroma Party, say 'Start a Chroma Party'","sentence2"]
     */
    constructor(props) {
        super(props);
        autoBind(this);
        this.avsWrapper = this.props.avsWrapper;
    }

    generateItemList(itemList){
        if (!(itemList instanceof Array)){ return;}
        let res = itemList.map((item,index)=>{
            return <li key={index} className="skill-detail-item alexa-padding-4">{item}</li>
        });
        return res;
    }

    render() {
        let itemList = this.props.list;
        let htmlList = this.generateItemList(itemList);

        return (
            <div className="skill-item-container skill-detail">
                <div className="skill-item-content alexa-padding-16 alexa-flex-column-jleft">
                    {htmlList}
                </div>
            </div>
        );
    }
}
export default RZSkillDetailItem;